var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddNo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 9.5,
    fill: "white",
    stroke: "#E2E4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 22C52.225 22 61 30.775 61 41.5C61 52.225 52.225 61 41.5 61C30.775 61 22 52.225 22 41.5C22 30.775 30.775 22 41.5 22ZM41.5 25.9C37.795 25.9 34.48 27.07 31.945 29.215L53.785 51.055C55.735 48.325 57.1 45.01 57.1 41.5C57.1 32.92 50.08 25.9 41.5 25.9ZM51.055 53.785L29.215 31.945C27.07 34.48 25.9 37.795 25.9 41.5C25.9 50.08 32.92 57.1 41.5 57.1C45.205 57.1 48.52 55.93 51.055 53.785Z",
    fill: "#A4379E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNo);
export default __webpack_public_path__ + "static/media/add_no.89fe1d9fd582ba597a810487abffa56a.svg";
export { ForwardRef as ReactComponent };